let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("2Mo2p")]).then(() => parcelRequire('lukLO'));